import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const supportedLngs = ["en", "zh-TW", "zh-CN"] as const;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs,
    ns: ["translation"],
    defaultNS: "translation",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    load: "languageOnly",
    // Map generic "zh" from browser to zh-CN (can override in switcher to zh-TW)
    nonExplicitSupportedLngs: true,
  });

// Preload other locales so switching language updates the UI immediately
i18n.loadLanguages(["zh-TW", "zh-CN"]).catch(() => {});

/** Get date-fns locale for current i18n language (for format(), formatDistance(), etc.). Use in async code or useEffect. */
export async function getDateFnsLocale() {
  const lng = i18n.language?.split("-")[0] ?? "en";
  if (lng === "zh") {
    const region = i18n.language?.toLowerCase().includes("tw") ? "TW" : "CN";
    const mod = region === "TW"
      ? await import("date-fns/locale/zh-TW")
      : await import("date-fns/locale/zh-CN");
    return (mod as Record<string, unknown>).default ?? mod;
  }
  const mod = await import("date-fns/locale/en-GB");
  return (mod as Record<string, unknown>).default ?? mod;
}

/** Current language normalized to a supported switcher value (en | zh-TW | zh-CN). */
export function getCurrentLanguageForSwitcher(): (typeof supportedLngs)[number] {
  const lng = (i18n.language || i18n.resolvedLanguage || "en").toLowerCase();
  if (lng.startsWith("zh")) {
    return lng.includes("tw") || lng.includes("hk") ? "zh-TW" : "zh-CN";
  }
  return "en";
}

export { supportedLngs };
export default i18n;
